import { Grid } from '@mui/material';
import { SelectMenu } from '@dtsl/react';
import { useAppState } from '../../../state';
import { useTranslation } from 'react-i18next';

const MAX_PARTICIPANT_OPTIONS = [6, 12, 24];

export default function MaxGalleryViewParticipants() {
  const { maxGalleryViewParticipants, setMaxGalleryViewParticipants } = useAppState();
  const { t } = useTranslation();

  const options = MAX_PARTICIPANT_OPTIONS.map((option) => ({
    key: option.toString(),
    value: option,
    label: option.toString(),
  }));

  const currentValue = [
    {
      key: maxGalleryViewParticipants.toString(),
      value: maxGalleryViewParticipants,
      label: maxGalleryViewParticipants.toString(),
    },
  ];

  return (
    <div>
      <Grid container alignItems="center" justifyContent="space-between">
        <div className="inputSelect">
          <SelectMenu
            label={t('ROOM.GALLERY_VIEW_PARTICIPANTS')}
            options={options}
            onSelect={(selected: { value: number }) => {
              setMaxGalleryViewParticipants(selected.value);
            }}
            value={currentValue}
          />
        </div>
      </Grid>
    </div>
  );
}
